"use client";
import React, { useEffect, useState } from "react";
import {
  Row,
  Col,
  Button,
} from "reactstrap";
import { useLocation, Link } from "react-router-dom";
import { getVendorListFormDetailById } from "./Action/index";
import LoaderCustom from "../../common/LoaderCustom";

const ViewVendorSupplierNeedForm = ({ setApplicationRegistrationStatus, setViewDataFromSupplier, setIsAssesmentRequired, setIsSelfAssessmentSubmittedByRequester }) => {
  const location = useLocation();
  const [loading, setLoading] = useState(false);
  const [getByIdData, setGetByIdData] = useState();
  const searchParams = new URLSearchParams(location.search);
  const vendorId = searchParams.get("VendorRequirementRegistrationId");

  useEffect(() => {
    if (vendorId) {
      setLoading(true);


      // Function to fetch data after a 3-second delay
      const fetchDataWithDelay = async () => {
        await new Promise(resolve => setTimeout(resolve, 3000));

        try {
          const res = await getVendorListFormDetailById(vendorId);
          const userDataPotentialsupplier = res?.Data;
          const data = { ...userDataPotentialsupplier[0] };
          setGetByIdData(data);
          setViewDataFromSupplier(data)
          setApplicationRegistrationStatus(data?.Status);
          setIsSelfAssessmentSubmittedByRequester(data?.IsSelfAssessmentSubmittedByRequester)
          setIsAssesmentRequired(data?.IsSelfAssessmentRequired);
        } catch (error) {
          console.error("Error fetching data:", error);
        } finally {
          setLoading(false);
        }
      };

      fetchDataWithDelay();
    }
  }, []);
  const handleDownload = (file) => {
    if (file) {
      // Create a hidden anchor element to trigger the download
      const link = document.createElement("a");

      if (typeof file === "string") {
        // If it's a string and starts with 'http', assume it's a URL
        link.href = file;

      } else {
        // Handle other cases or throw an error
        console.error("Unsupported file type");
        return;
      }

      link.target = "_blank";
      link.download = "downloadedFile";

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  };
  return (
    <div>
      <>
        {loading ? (
          <LoaderCustom customClass="simulation-Loader loader-center hl-loader-fixed" />
        ) : (
          ""
        )}
        <div className="hl-supplier-page">
          <Row className={`pt-2`} noGutters>
            <Col md="4" className="mb-2">
              <h1>View Supplier Need Form</h1>
            </Col>
            <Col md="8" className="mb-3 d-flex justify-content-end">
              <button
                type="button"
                className={"apply mt-1"}
                onClick={() => window.history.back()}
              >
                <div className={"back-icon"}></div>Back
              </button>
            </Col>
          </Row>
          <Row gutter={20} className="mb-4">
            <Col xs={24} sm={24} md={24} lg={24} xl={24}>
              <Row
                className="non-registered-supplier-details-right text-left"
                gutter={[20, 24]}
              >
                <Col sm={24} md={6}>
                  <Row>
                    <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                      <h3 className="sd-common-heading">
                        Application Details
                      </h3>
                    </Col>
                  </Row>
                  <Row className="hl-detail-column m-0">
                    <Col
                      md={6}
                      className="hl-heading-details"
                    >
                      <span className="hl-title-details">Supplier Name</span>
                    </Col>
                    <Col
                      md={6}
                      className="pr-6 hl-descmain-details"
                    >
                      <span className="hl-desc-details">
                        {getByIdData?.VendorName}
                      </span>
                    </Col>

                    <Col
                      md={6}
                      className="hl-heading-details"
                    >
                      <span className="hl-title-details">Plant</span>
                    </Col>
                    <Col
                      md={6}
                      className="pr-6 hl-descmain-details"
                    >
                      <span className="hl-desc-details">
                        {getByIdData?.PlantName}
                      </span>
                    </Col>

                    <Col
                      md={6}
                      className="hl-heading-details"
                    >
                      <span className="hl-title-details">Category</span>
                    </Col>
                    <Col
                      md={6}
                      className="pr-6 hl-descmain-details"
                    >
                      <span className="hl-desc-details">
                        {getByIdData?.CategoryName}
                      </span>
                    </Col>
                    <Col
                      md={6}
                      className="hl-heading-details"
                    >
                      <span className="hl-title-details">
                        Supplier Specialization
                      </span>
                    </Col>
                    <Col
                      md={6}
                      className="pr-6 hl-descmain-details"
                    >
                      <span className="hl-desc-details">
                        {getByIdData?.SupplierSpecializationName}
                      </span>
                    </Col>
                    <Col
                      md={6}
                      className="hl-heading-details"
                    >
                      <span className="hl-title-details">
                        Other Specialization
                      </span>
                    </Col>
                    <Col
                      md={6}
                      className="pr-6 hl-descmain-details"
                    >
                      <span className="hl-desc-details">
                        {getByIdData?.OtherSupplierSpecializationName ? getByIdData?.OtherSupplierSpecializationName : "-"}
                      </span>
                    </Col>
                    <>
                      <Col
                        xs={24}
                        sm={12}
                        md={12}
                        lg={12}
                        xl={12}
                        className="hl-heading-details"
                      >
                        <span className="hl-title-details">Division</span>
                      </Col>
                      <Col
                        xs={24}
                        sm={12}
                        md={12}
                        lg={12}
                        xl={12}
                        className="pr-6 hl-descmain-details"
                      >
                        <span className="hl-desc-details">
                          {getByIdData?.DivisionName ? getByIdData?.DivisionName : "-"}
                        </span>
                      </Col>
                    </>
                    <Col
                      md={6}
                      className="hl-heading-details"
                    >
                      <span className="hl-title-details">
                        Expected Business/Year(INR)
                      </span>
                    </Col>
                    <Col
                      md={6}
                      className="pr-6 hl-descmain-details"
                    >
                      <span className="hl-desc-details">
                        {getByIdData?.ExpectedBusiness} Lakh
                      </span>
                    </Col>

                    <Col
                      md={6}
                      className="hl-heading-details"
                    >
                      <span className="hl-title-details">Payment Terms</span>
                    </Col>
                    <Col
                      md={6}
                      className="pr-6 hl-descmain-details"
                    >
                      <span className="hl-desc-details">
                        {getByIdData?.PaymentTermsName}
                      </span>
                    </Col>

                    <Col
                      md={6}
                      className="hl-heading-details"
                    >
                      <span className="hl-title-details">
                        Payment Term Remark
                      </span>
                    </Col>
                    <Col
                      md={6}
                      className="pr-6 hl-descmain-details"
                    >
                      <span className="hl-desc-details">
                        {getByIdData?.PaymenttermsRemarks ? (
                          <>
                            {getByIdData?.PaymenttermsRemarks}
                          </>
                        ) : (
                          <span>-</span>
                        )}
                      </span>
                    </Col>
                  </Row>
                  <Row className="mt-4">
                    <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                      <h3 className="sd-common-heading">Supplier Details</h3>
                    </Col>
                  </Row>
                  <Row className="hl-detail-column m-0">
                    <Col
                      md={6}
                      className="hl-heading-details"
                    >
                      <span className="hl-title-details">
                        Supplier Origin
                      </span>
                    </Col>
                    <Col
                      md={6}
                      className="pr-6 hl-descmain-details"
                    >
                      <span className="hl-desc-details">
                        {getByIdData?.SupplierOriginName}
                      </span>
                    </Col>

                    <Col
                      md={6}
                      className="hl-heading-details"
                    >
                      <span className="hl-title-details">
                        Supplier Relation
                      </span>
                    </Col>
                    <Col
                      md={6}
                      className="pr-6 hl-descmain-details"
                    >
                      <span className="hl-desc-details">
                        {getByIdData?.VendorRelationName}
                      </span>
                    </Col>

                    <Col
                      md={6}
                      className="hl-heading-details"
                    >
                      <span className="hl-title-details">Company Name</span>
                    </Col>
                    <Col
                      md={6}
                      className="pr-6 hl-descmain-details"
                    >
                      <span className="hl-desc-details">
                        {getByIdData?.VendorName}
                      </span>
                    </Col>

                    <Col
                      md={6}
                      className="hl-heading-details"
                    >
                      <span className="hl-title-details">
                        Origin of Sources/Ref
                      </span>
                    </Col>
                    <Col
                      md={6}
                      className="pr-6 hl-descmain-details"
                    >
                      <span className="hl-desc-details">
                        {getByIdData?.SupplierOriginSourcesName}
                      </span>
                    </Col>

                    <Col
                      md={6}
                      className="hl-heading-details"
                    >
                      <span className="hl-title-details">
                        Contact Person Name
                      </span>
                    </Col>
                    <Col
                      md={6}
                      className="pr-6 hl-descmain-details"
                    >
                      <span className="hl-desc-details">
                        {getByIdData?.ContactPersonName}
                      </span>
                    </Col>

                    <Col
                      md={6}
                      className="hl-heading-details"
                    >
                      <span className="hl-title-details">Designation</span>
                    </Col>
                    <Col
                      md={6}
                      className="pr-6 hl-descmain-details"
                    >
                      <span className="hl-desc-details">
                        {getByIdData?.ContactPersonDesignation}
                      </span>
                    </Col>

                    <Col
                      md={6}
                      className="hl-heading-details"
                    >
                      <span className="hl-title-details">
                        Year of Business Incorporation
                      </span>
                    </Col>
                    <Col
                      md={6}
                      className="pr-6 hl-descmain-details"
                    >
                      <span className="hl-desc-details">
                        {getByIdData?.Establishment_Year}
                      </span>
                    </Col>

                    {getByIdData?.EstablishmentRemarks && (
                      <>
                        <Col
                          xs={24}
                          sm={12}
                          md={12}
                          lg={12}
                          xl={12}
                          className="hl-heading-details"
                        >
                          <span className="hl-title-details">
                            Year of Incorporation Remarks
                          </span>
                        </Col>
                        <Col
                          xs={24}
                          sm={12}
                          md={12}
                          lg={12}
                          xl={12}
                          className="pr-6 hl-descmain-details"
                        >
                          <span className="hl-desc-details">
                            {getByIdData?.EstablishmentRemarks}
                          </span>
                        </Col>
                      </>
                    )}

                    <Col
                      md={6}
                      className="hl-heading-details"
                    >
                      <span className="hl-title-details">Contact Number</span>
                    </Col>
                    <Col
                      md={6}
                      className="pr-6 hl-descmain-details"
                    >
                      <span className="hl-desc-details">
                        {getByIdData?.MobileNo}
                      </span>
                    </Col>

                    <Col
                      md={6}
                      className="hl-descmain-details"
                    >
                      <span className="hl-title-details">
                        Primary Email Address
                      </span>
                    </Col>
                    <Col
                      md={6}
                      className="pr-6 hl-descmain-details"
                    >
                      <span className="hl-desc-details">
                        <Link href={`mailto:${getByIdData?.Email}`}>
                          {getByIdData?.Email}
                        </Link>
                      </span>
                    </Col>
                  </Row>
                  <Row className="mt-4">
                    <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                      <h3 className="sd-common-heading">Work Address</h3>
                    </Col>
                  </Row>
                  <Row className="hl-detail-column m-0 mb-4">
                    <Col
                      md={6}
                      className="hl-heading-details"
                    >
                      <span className="hl-title-details">Country</span>
                    </Col>
                    <Col
                      md={6}
                      className="pr-6 hl-descmain-details"
                    >
                      <span className="hl-desc-details">
                        {getByIdData?.CountryName}
                      </span>
                    </Col>
                    <Col
                      md={6}
                      className="hl-heading-details"
                    >
                      <span className="hl-title-details">State</span>
                    </Col>
                    <Col
                      md={6}
                      className="pr-6 hl-descmain-details"
                    >
                      <span className="hl-desc-details">
                        {getByIdData?.StateName}
                      </span>
                    </Col>
                    <Col
                      md={6}
                      className="hl-descmain-details"
                    >
                      <span className="hl-title-details">District</span>
                    </Col>
                    <Col
                      md={6}
                      className="pr-6 hl-descmain-details"
                    >
                      <span className="hl-desc-details">
                        {getByIdData?.District}
                      </span>
                    </Col>
                    <Col
                      md={6}
                      className="hl-heading-details"
                    >
                      <span className="hl-title-details">City</span>
                    </Col>
                    <Col
                      md={6}
                      className="pr-6 hl-descmain-details"
                    >
                      <span className="hl-desc-details">
                        {getByIdData?.City}
                      </span>
                    </Col>
                  </Row>
                </Col>
                <Col sm={24} md={6}>
                  <Row>
                    <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                      <h3 className="sd-common-heading">
                        Why This New Supplier Required
                      </h3>
                    </Col>
                  </Row>
                  <Row className="hl-detail-column m-0">
                    {/* <Col
                      md={6}
                      className="hl-heading-details"
                    >
                      <span className="hl-title-details">
                        New Business Vertical/Products
                      </span>
                    </Col>
                    <Col
                      md={6}
                      className="pr-6 hl-descmain-details"
                    >
                      <span className="hl-desc-details">
                        {getByIdData?.NewBusinessVerticalName}
                      </span>
                    </Col> */}
                    <Col
                      md={6}
                      className="hl-descmain-details"
                    >
                      <span className="hl-title-details">
                        Import localization
                      </span>
                    </Col>
                    <Col
                      md={6}
                      className="pr-6 hl-descmain-details"
                    >
                      <span className="hl-desc-details">
                        {getByIdData?.ImportlocalizationName}
                      </span>
                    </Col>
                    <Col
                      md={6}
                      className="hl-heading-details"
                    >
                      <span className="hl-title-details">
                        Due to Single Source
                      </span>
                    </Col>
                    <Col
                      md={6}
                      className="pr-6 hl-descmain-details"
                    >
                      <span className="hl-desc-details">
                        {getByIdData?.DuetoSingleSourceName}
                      </span>
                    </Col>

                    {getByIdData?.CostSavingName && (
                      <>
                        <Col
                          xs={24}
                          sm={12}
                          md={12}
                          lg={12}
                          xl={12}
                          className="hl-descmain-details"
                        >
                          <span className="hl-title-details">
                            Cost Saving
                          </span>
                        </Col>
                        <Col
                          xs={24}
                          sm={12}
                          md={12}
                          lg={12}
                          xl={12}
                          className="pr-6 hl-descmain-details"
                        >
                          <span className="hl-desc-details">
                            {getByIdData?.CostSavingName}
                          </span>
                        </Col>
                      </>
                    )}

                    {getByIdData?.CostSavingName === "YES" && (
                      <>
                        <Col
                          xs={24}
                          sm={12}
                          md={12}
                          lg={12}
                          xl={12}
                          className="hl-heading-details"
                        >
                          <span className="hl-title-details">
                            How Much Annually?
                          </span>
                        </Col>
                        <Col
                          xs={24}
                          sm={12}
                          md={12}
                          lg={12}
                          xl={12}
                          className="pr-6 hl-descmain-details"
                        >
                          <span className="hl-desc-details">
                            {getByIdData?.HowMuchAnnuallyCostSaving} Lakh
                          </span>
                        </Col>

                        <Col
                          xs={24}
                          sm={12}
                          md={12}
                          lg={12}
                          xl={12}
                          className="hl-heading-details"
                        >
                          <span className="hl-title-details">
                            What Percent Annually?
                          </span>
                        </Col>
                        <Col
                          xs={24}
                          sm={12}
                          md={12}
                          lg={12}
                          xl={12}
                          className="pr-6 hl-descmain-details"
                        >
                          <span className="hl-desc-details">
                            {getByIdData?.WhatPercentAnnuallyCostSaving}%
                          </span>
                        </Col>
                      </>
                    )}

                    {getByIdData?.CostSavingDocumentUrl && (
                      <>
                        <Col
                          xs={24}
                          sm={12}
                          md={12}
                          lg={12}
                          xl={12}
                          className="hl-heading-details"
                        >
                          <span className="hl-title-details">
                            Upload Evidence
                          </span>
                        </Col>
                        <Col
                          xs={24}
                          sm={12}
                          md={12}
                          lg={12}
                          xl={12}
                          className="pr-6 hl-descmain-details"
                        >
                          <span className="hl-desc-details text-uppercase justify-content-end pr-0">
                            <Button
                              className="hl-upload-btn hl-mb-0"
                              title="Download"
                              onClick={() => {
                                handleDownload(
                                  getByIdData?.CostSavingDocumentUrl
                                );
                              }}
                              disabled={false}
                            >
                              <div className="download mr-0"></div>
                            </Button>
                          </span>
                        </Col>
                      </>
                    )}
                    {getByIdData?.CostSheetName && (
                      <>
                        <Col
                          xs={24}
                          sm={12}
                          md={12}
                          lg={12}
                          xl={12}
                          className="hl-descmain-details">
                          <span className="hl-title-details">Cost Sheet</span>
                        </Col>
                        <Col
                          xs={24}
                          sm={12}
                          md={12}
                          lg={12}
                          xl={12}
                          className="pr-6 hl-descmain-details">
                          <span className={`hl-desc-details justify-content-between pr-0 ${getByIdData?.CostSheetName === "No" ? " " : ""}`}>
                            {getByIdData?.CostSheetName}
                            {getByIdData?.CostSheetDocumentUrl && (
                              <Button
                                className="hl-upload-btn hl-mb-0"
                                title="Download"
                                onClick={() => {
                                  handleDownload(
                                    getByIdData?.CostSheetDocumentUrl
                                  );
                                }}
                                disabled={false}
                              >
                                <div className="download mr-0"></div>
                              </Button>
                            )}
                          </span>
                        </Col>
                      </>
                    )}
                    {getByIdData?.CompanyRegistrationOrLicenseAttachmentUrl && (
                      <>
                        <Col
                          xs={24}
                          sm={12}
                          md={12}
                          lg={12}
                          xl={12}
                          className="hl-descmain-details"
                        >
                          <span className="hl-title-details">
                            Company Registration Or License Attachment
                          </span>
                        </Col>
                        <Col
                          xs={24}
                          sm={12}
                          md={12}
                          lg={12}
                          xl={12}
                          className="pr-6 hl-descmain-details"
                        >
                          <span className="hl-desc-details text-uppercase justify-content-end pr-0">
                            <Button
                              className="hl-upload-btn hl-mb-0"
                              title="Download"
                              onClick={() => {
                                handleDownload(
                                  getByIdData?.CompanyRegistrationOrLicenseAttachmentUrl
                                );
                              }}
                              disabled={false}
                            >
                              <div className="download mr-0"></div>
                            </Button>
                          </span>
                        </Col>
                      </>
                    )}
                    {getByIdData?.ReplacementExistingVendorName && (
                      <>
                        <Col
                          xs={24}
                          sm={12}
                          md={12}
                          lg={12}
                          xl={12}
                          className="hl-descmain-details"
                        >
                          <span className="hl-title-details">
                            Replacement of Existing Supplier (For Code Closure)
                          </span>
                        </Col>
                        <Col
                          xs={24}
                          sm={12}
                          md={12}
                          lg={12}
                          xl={12}
                          className="pr-6 hl-descmain-details"
                        >
                          <span className="hl-desc-details">
                            {getByIdData?.ReplacementExistingVendorName}
                          </span>
                        </Col>
                      </>
                    )}
                    {getByIdData?.ReplacementExistingVendorName === "YES" && (
                      <>
                        <Col
                          xs={24}
                          sm={12}
                          md={12}
                          lg={12}
                          xl={12}
                          className="hl-heading-details"
                        >
                          <span className="hl-title-details">
                            Replacement of Existing Supplier (For Code Closure)
                          </span>
                        </Col>
                        <Col
                          xs={24}
                          sm={12}
                          md={12}
                          lg={12}
                          xl={12}
                          className="pr-6 hl-descmain-details"
                        >
                          <span className="hl-desc-details">
                            {getByIdData?.ReplacementofExistingVendorCode}
                          </span>
                        </Col>

                        <Col
                          xs={24}
                          sm={12}
                          md={12}
                          lg={12}
                          xl={12}
                          className="hl-heading-details"
                        >
                          <span className="hl-title-details">
                            Existing Payment Terms
                          </span>
                        </Col>
                        <Col
                          xs={24}
                          sm={12}
                          md={12}
                          lg={12}
                          xl={12}
                          className="pr-6 hl-descmain-details"
                        >
                          <span className="hl-desc-details">
                            {getByIdData?.ExistingPaymentTerms}
                          </span>
                        </Col>
                      </>
                    )}
                    <Col
                      md={6}
                      className="hl-descmain-details"
                    >
                      <span className="hl-title-details">
                        Commercial Reason
                      </span>
                    </Col>
                    <Col
                      md={6}
                      className="pr-6 hl-descmain-details"
                    >
                      <span className="hl-desc-details">
                        {getByIdData?.CommercialText}
                      </span>
                    </Col>

                    {getByIdData?.CommercialText === "YES" && (
                      <>
                        <Col
                          xs={24}
                          sm={12}
                          md={12}
                          lg={12}
                          xl={12}
                          className="hl-descmain-details"
                        >
                          <span className="hl-title-details">
                            Commercial Reason Specification
                          </span>
                        </Col>
                        <Col
                          xs={24}
                          sm={12}
                          md={12}
                          lg={12}
                          xl={12}
                          className="pr-6 hl-descmain-details"
                        >
                          <span className="hl-desc-details">
                            {getByIdData?.CommercialReasonName}
                          </span>
                        </Col>
                      </>
                    )}

                    {getByIdData?.OtherName === "YES" && (
                      <>
                        <Col
                          xs={24}
                          sm={12}
                          md={12}
                          lg={12}
                          xl={12}
                          className="hl-heading-details"
                        >
                          <span className="hl-title-details">
                            Other Reason (Capex, Jobs, Worker, Service, etc.)
                          </span>
                        </Col>
                        <Col
                          xs={24}
                          sm={12}
                          md={12}
                          lg={12}
                          xl={12}
                          className="pr-6 hl-descmain-details"
                        >
                          <span className="hl-desc-details">
                            {getByIdData?.OtherName}
                          </span>
                        </Col>
                      </>
                    )}
                    {getByIdData?.OtherName && (
                      <>
                        <Col
                          xs={24}
                          sm={12}
                          md={12}
                          lg={12}
                          xl={12}
                          className="hl-descmain-details"
                        >
                          <span className="hl-title-details">
                            Specify Other Reason
                          </span>
                        </Col>
                        <Col
                          xs={24}
                          sm={12}
                          md={12}
                          lg={12}
                          xl={12}
                          className="pr-6 hl-descmain-details"
                        >
                          <span className="hl-desc-details">
                            {getByIdData?.OtherReason ? (
                              <>
                                {getByIdData?.OtherReason}
                              </>
                            ) : (
                              <span>-</span>
                            )}
                          </span>
                        </Col>
                      </>
                    )}
                    <Col
                      xs={24}
                      sm={12}
                      md={12}
                      lg={12}
                      xl={12}
                      className="hl-descmain-details"
                    >
                      <span className="hl-title-details">
                        Company Profile
                      </span>
                    </Col>
                    <Col
                      xs={24}
                      sm={12}
                      md={12}
                      lg={12}
                      xl={12}
                      className="pr-6 hl-descmain-details"
                    >
                      {getByIdData?.CompanyProfileDocumentUrl || getByIdData?.CompanyProfileAttachmentUrl ? (
                        <span className="hl-desc-details justify-content-end pr-0">
                          <Button
                            onClick={() => {
                              handleDownload(getByIdData.CompanyProfileDocumentUrl || getByIdData?.CompanyProfileAttachmentUrl);
                            }}
                            disabled={false}
                            title="Download"
                            className="hl-upload-btn hl-mb-0"
                          >
                            <div className="download mr-0"></div>
                          </Button>
                        </span>
                      ) : (
                        <span className="hl-desc-details">-</span>
                      )}
                    </Col>
                    {getByIdData?.CompanyProfileWebsite && (
                      <>
                        <Col
                          xs={24}
                          sm={12}
                          md={12}
                          lg={12}
                          xl={12}
                          className="hl-heading-details"
                        >
                          <span className="hl-title-details">Website</span>
                        </Col>
                        <Col
                          xs={24}
                          sm={12}
                          md={12}
                          lg={12}
                          xl={12}
                          className="pr-6 hl-descmain-details"
                        >
                          <span className="hl-desc-details">
                            {/* <a
                              target="_blank"
                              href={getByIdData?.CompanyProfileWebsite ? getByIdData?.CompanyProfileWebsite : "#"}
                            > */}
                            {getByIdData?.CompanyProfileWebsite ? getByIdData?.CompanyProfileWebsite : "-"}
                            {/* </a> */}
                          </span>
                        </Col>
                      </>
                    )}
                    <Col
                      md={6}
                      className="hl-heading-details"
                    >
                      <span className="hl-title-details">
                        Part/FG/Service/Description (for which Supplier has
                        been identified)
                      </span>
                    </Col>
                    <Col
                      md={6}
                      className="pr-6 hl-descmain-details"
                    >
                      <span className="hl-desc-details">
                        {getByIdData?.SupplierServiceDescription}
                      </span>
                    </Col>

                    {getByIdData?.ExistingSupplierAvialableAndDiscussionName && (
                      <>
                        <Col
                          xs={24}
                          sm={12}
                          md={12}
                          lg={12}
                          xl={12}
                          className="hl-descmain-details"
                        >
                          <span className="hl-title-details">
                            Existing Supplier Available & Discussions done?
                          </span>
                        </Col>
                        <Col
                          xs={24}
                          sm={12}
                          md={12}
                          lg={12}
                          xl={12}
                          className="pr-6 hl-descmain-details"
                        >
                          <span className="hl-desc-details">
                            {
                              getByIdData?.ExistingSupplierAvialableAndDiscussionName
                            }
                          </span>
                        </Col>
                      </>
                    )}
                    {getByIdData?.ExistingSupplierAvialableAndDiscussionName ===
                      "YES" && (
                        <>
                          <Col
                            xs={24}
                            sm={12}
                            md={12}
                            lg={12}
                            xl={12}
                            className="hl-heading-details"
                          >
                            <span className="hl-title-details">
                              Existing Supplier Available Number
                            </span>
                          </Col>
                          <Col
                            xs={24}
                            sm={12}
                            md={12}
                            lg={12}
                            xl={12}
                            className="pr-6 hl-descmain-details"
                          >
                            <span className="hl-desc-details">
                              {
                                getByIdData?.ExistingSupplierAvialableAndDiscusionComment
                              }
                            </span>
                          </Col>
                        </>
                      )}
                    <Col
                      md={6}
                      className="hl-descmain-details"
                    >
                      <span className="hl-title-details">
                        Feedback of Existing Supplier
                      </span>
                    </Col>
                    <Col
                      md={6}
                      className="pr-6 hl-descmain-details"
                    >
                      <span className="hl-desc-details">
                        {getByIdData?.ExistingSupplierFeedback}
                      </span>
                    </Col>
                    {getByIdData?.DiscussionWithNDTTeamName && (
                      <>
                        <Col
                          xs={24}
                          sm={12}
                          md={12}
                          lg={12}
                          xl={12}
                          className="hl-descmain-details"
                        >
                          <span className="hl-title-details">
                            Discuss with Central Category NPD/Team
                          </span>
                        </Col>
                        <Col
                          xs={24}
                          sm={12}
                          md={12}
                          lg={12}
                          xl={12}
                          className="pr-6 hl-descmain-details"
                        >
                          <span className="hl-desc-details">
                            {getByIdData?.DiscussionWithNDTTeamName}
                          </span>
                        </Col>
                      </>
                    )}
                    {getByIdData?.DiscussionWithNDTTeamName === "YES" && (
                      <>
                        <Col
                          xs={24}
                          sm={12}
                          md={12}
                          lg={12}
                          xl={12}
                          className="hl-heading-details"
                        >
                          <span className="hl-title-details">
                            Discuss with Central Category NPD/Team Certificate Number
                          </span>
                        </Col>
                        <Col
                          xs={24}
                          sm={12}
                          md={12}
                          lg={12}
                          xl={12}
                          className="pr-6 hl-descmain-details"
                        >
                          <span className="hl-desc-details">
                            {getByIdData?.DiscussionWithNDTTeamComment}
                          </span>
                        </Col>
                      </>
                    )}
                    <Col
                      md={6}
                      className="hl-heading-details"
                    >
                      <span className="hl-title-details">
                        Estimated Start of Supplies (Month)
                      </span>
                    </Col>
                    <Col
                      md={6}
                      className="pr-6 hl-descmain-details"
                    >
                      <span className="hl-desc-details">
                        {getByIdData?.EstimatedStartOfSuppies}
                      </span>
                    </Col>
                    {/* <Col
                      md={6}
                      className="hl-heading-details"
                    >
                      <span className="hl-title-details">
                        Location Change of Existing Supplier
                      </span>
                    </Col> */}
                    {/* <Col
                      md={6}
                      className="pr-6 hl-descmain-details"
                    >
                      <span className="hl-desc-details">
                        {getByIdData?.LocationChangeOfExistingSupplierName}
                      </span>
                    </Col> */}
                    {getByIdData?.NewLocationAddedByExistingSupplierName && (
                      <>
                        <Col
                          xs={24}
                          sm={12}
                          md={12}
                          lg={12}
                          xl={12}
                          className="hl-descmain-details"
                        >
                          <span className="hl-title-details">
                            New Location Added by Existing Supplier
                          </span>
                        </Col>
                        <Col
                          xs={24}
                          sm={12}
                          md={12}
                          lg={12}
                          xl={12}
                          className="pr-6 hl-descmain-details"
                        >
                          <span className="hl-desc-details">
                            {
                              getByIdData?.NewLocationAddedByExistingSupplierName
                            }
                          </span>
                        </Col>
                      </>
                    )}
                    {getByIdData?.NewLocationAddedByExistingSupplierName ===
                      "YES" && (
                        <>
                          <Col
                            xs={24}
                            sm={12}
                            md={12}
                            lg={12}
                            xl={12}
                            className="hl-heading-details"
                          >
                            <span className="hl-title-details">
                              New Location Certificate Number
                            </span>
                          </Col>
                          <Col
                            xs={24}
                            sm={12}
                            md={12}
                            lg={12}
                            xl={12}
                            className="pr-6 hl-descmain-details"
                          >
                            <span className="hl-desc-details">
                              {
                                getByIdData?.NewLocationAddedByExistingSupplierComment
                              }
                            </span>
                          </Col>
                        </>
                      )}
                    <Col
                      md={6}
                      className="hl-heading-details"
                    >
                      <span className="hl-title-details">
                        Why existing suppliers currently associated with group cannot fulfil the need? (Please give justification)
                      </span>
                    </Col>
                    <Col
                      md={6}
                      className="pr-6 hl-descmain-details"
                    >
                      <span className="hl-desc-details">
                        {getByIdData?.Remarks ? (
                          <>
                            {getByIdData?.Remarks}
                          </>
                        ) : (
                          <span>-</span>
                        )}
                      </span>
                    </Col>
                    {getByIdData?.SaveriskDocumentUrl && (
                      <>
                        <Col
                          xs={24}
                          sm={12}
                          md={12}
                          lg={12}
                          xl={12}
                          className="hl-heading-details"
                        >
                          <span className="hl-title-details">
                            Save Risk Document
                          </span>
                        </Col>
                        <Col
                          xs={24}
                          sm={12}
                          md={12}
                          lg={12}
                          xl={12}
                          className="pr-6 hl-descmain-details"
                        >
                          <span className="hl-desc-details text-uppercase justify-content-end pr-0">
                            <Button
                              // icon={<DownloadOutlined />}
                              title="Download"
                              className="hl-upload-btn hl-mb-0"
                              onClick={() => {
                                handleDownload(
                                  getByIdData?.SaveriskDocumentUrl
                                );
                              }}
                              disabled={false}
                            >
                              <div className="download mr-0"></div>
                            </Button>
                          </span>
                        </Col>
                      </>
                    )}
                  </Row>
                </Col>
              </Row>
            </Col>
          </Row>
        </div>
      </>
    </div>
  );
};

export default ViewVendorSupplierNeedForm;
